/* GASTRO&CO. B2B price display: Shopify prices are shown as NET prices. */
(function () {
  'use strict';

  var VAT_RATE = 1.19;
  var SELECTORS = '.product-item__price-list.price-list, .product-form__info-content > .price-list';

  function parseGermanMoney(text) {
    var matches = String(text || '').match(/\d{1,3}(?:\.\d{3})*(?:,\d{2})|\d+(?:,\d{2})?/g) || [];
    return matches.map(function (value) {
      return Number(value.replace(/\./g, '').replace(',', '.'));
    }).filter(function (value) { return Number.isFinite(value); });
  }

  function formatEUR(value) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }

  function grossText(values) {
    if (!values.length) return '';
    var gross = values.map(function (value) {
      return Math.round(value * VAT_RATE * 100) / 100;
    });
    if (gross.length > 1 && gross[0] !== gross[gross.length - 1]) {
      return formatEUR(gross[0]) + ' – ' + formatEUR(gross[gross.length - 1]);
    }
    return formatEUR(gross[0]);
  }

  function applyPriceDisplay(container) {
    if (!container) return;

    var currentPrice = container.querySelector('.price:not(.price--compare)');
    if (!currentPrice) return;

    var source = currentPrice.textContent.trim();
    if (!source || container.dataset.gucPriceSource === source) return;

    var values = parseGermanMoney(source);
    if (!values.length) return;

    container.dataset.gucPriceSource = source;
    currentPrice.classList.add('guc-b2b-current-price');

    var oldMeta = container.parentElement && container.parentElement.querySelector(':scope > .guc-b2b-price-meta');
    if (oldMeta) oldMeta.remove();

    var meta = document.createElement('div');
    meta.className = 'guc-b2b-price-meta';
    meta.innerHTML = '<div class="guc-b2b-net-note">Netto · zzgl. 19 % MwSt.</div>' +
      '<div class="guc-b2b-gross">Brutto: <strong>' + grossText(values) + '</strong></div>';
    container.insertAdjacentElement('afterend', meta);
  }

  function hideConflictingTaxText() {
    document.querySelectorAll('.product-form__price-info').forEach(function (el) {
      var text = (el.textContent || '').toLowerCase();
      if ((text.indexOf('inkl') !== -1 && (text.indexOf('steuer') !== -1 || text.indexOf('mwst') !== -1)) || text.indexOf('taxes included') !== -1) {
        el.style.display = 'none';
      }
    });
  }

  function refresh() {
    document.querySelectorAll(SELECTORS).forEach(applyPriceDisplay);
    hideConflictingTaxText();
  }

  function addStyles() {
    if (document.getElementById('guc-b2b-price-styles')) return;
    var style = document.createElement('style');
    style.id = 'guc-b2b-price-styles';
    style.textContent = [
      '.guc-b2b-current-price{color:#c62828!important;font-weight:700!important;}',
      '.guc-b2b-price-meta{margin-top:4px;font-size:12px;line-height:1.35;color:#6b7280;}',
      '.guc-b2b-price-meta .guc-b2b-net-note{font-weight:600;}',
      '.guc-b2b-price-meta .guc-b2b-gross{margin-top:1px;}',
      '.product-form__info-content>.guc-b2b-price-meta{font-size:13px;margin-top:6px;}',
      '.product-form__info-content>.price-list .guc-b2b-current-price{font-size:1.12em;}'
    ].join('');
    document.head.appendChild(style);
  }

  function init() {
    addStyles();
    refresh();

    document.addEventListener('variant:changed', function () {
      window.setTimeout(refresh, 80);
    });

    var observer = new MutationObserver(function () {
      window.requestAnimationFrame(refresh);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
